import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const PlusIcon: FunctionComponent<Props> = ({ className = '', testId = TEST_ID }) => (
    <svg
        className={`${className} ${styles.plusIcon}`}
        data-testid={testId}
        fill='none'
        height='24'
        stroke='currentColor'
        strokeLinecap='round'
        strokeWidth='2.5'
        viewBox='0 0 24 24'
        width='24'
        xmlns='http://www.w3.org/2000/svg'>
        <path d='M12 5V19M5 12H19' />
    </svg>
);

export default PlusIcon;
